import { CategoryIds } from '../../CategoryTabs'
import { ProgressData, Service, MappedProgressData } from '../types'

type MapProgressData = (
  progressData?: ProgressData,
  serviceData?: Record<keyof ProgressData, Service>,
) => MappedProgressData

const groupedWidgets: Record<CategoryIds, string[]> = {
  resumes: ['resume_crafting', 'resume_tailoring', 'resume_distribution', 'cover_letter_crafting'],
  jobs: ['job_applications', 'resume_distribution', 'job_search_strategy'],
  interviews: [
    'interview_practice',
    'questions_practice',
    'interview_strategy',
    'interviews_passed',
  ],
  careers: ['ninty_days_plan', 'promotion_plan', 'career_switch'],
}

export const mapProgressData: MapProgressData = (progressData, serviceData) => {
  const mappedProgressData: MappedProgressData = {
    resumes: [],
    jobs: [],
    interviews: [],
    careers: [],
  }

  for (const widgetCategory in groupedWidgets) {
    const category = widgetCategory as CategoryIds
    const widgets = groupedWidgets[category]

    for (const widget of widgets) {
      const widgetKey = widget as keyof ProgressData
      const value = progressData?.[widgetKey]
      const service = serviceData?.[widgetKey]
      if (!service) continue

      mappedProgressData[category].push({
        ...service,
        data: value || {},
        progress: value?.progress || 0,
      })
    }
  }

  return mappedProgressData
}
